import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const PROMO_CONTENT = "promoContent";
const STATS = "stats";
const NEXT_ACTIONS = "nextActions";
const SYSTEM_NOTIFICATIONS = "systemNotifications";

export const dashboardKeys = createKeys(featureKeys.DASHBOARD, {
  promoContent: () => [PROMO_CONTENT],
  stats: () => [STATS],
  nextActions: () => [NEXT_ACTIONS],
  systemNotifications: () => [SYSTEM_NOTIFICATIONS],
});
